/**
 * Mirrors the guest-facing copy in www-savibook
 * (src/pages/OtaBusterCapture/campaignCopy.js) so admins can preview each step
 * without leaving the dashboard. Keep both files in sync when copy changes.
 */

const interpolate = (template, { first, hotel }) =>
  (template || '')
    .replace(/\{first\}/g, first || 'there')
    .replace(/\{hotel\}/g, hotel || 'the hotel')

export function getSavibookPreviewCopy(step, { firstName, hotelName } = {}) {
  const first = firstName || 'there'
  const hotel = hotelName || 'the hotel'
  const vars = { first, hotel }

  const configs = {
    'just-booked': {
      header: 'Thanks for Booking!',
      body: interpolate(
        "Hi {first}, your stay at {hotel} is confirmed. Let's get a few details squared away before you arrive.",
        vars
      ),
      cta: 'View My Reservation',
      successTitle: "You're all booked!",
      successBody: interpolate(
        "Thank you, {first}. Your reservation is confirmed and we'll be in touch as your stay gets closer.",
        vars
      ),
      successClosing: interpolate("We can't wait to welcome you to {hotel}!", vars)
    },
    'pre-check-in': {
      header: 'Complete Your Pre-Check-In',
      body: interpolate(
        'Hi {first}, your stay is almost here. Finish these quick steps to skip the front desk line — no credit card needed.',
        vars
      ),
      cta: 'Complete Pre-Check-In',
      successTitle: "You're all set!",
      successBody:
        'Thank you for completing your pre-check-in. When you arrive, simply stop by the front desk to pick up your keys.',
      successClosing: interpolate("We can't wait to welcome you to {hotel}!", vars)
    },
    'pre-check-in-reminder': {
      header: 'See You Tomorrow',
      body: interpolate(
        "Hi {first}, we can't wait to welcome you tomorrow. You haven't finished your pre-check-in yet — just two things left and you can skip the front desk line.",
        vars
      ),
      cta: 'Finish Pre-Check-In',
      successTitle: "You're all set!",
      successBody:
        "Thanks for confirming your arrival details. We'll see you tomorrow — just stop by the front desk to pick up your keys.",
      successClosing: interpolate("We can't wait to welcome you to {hotel}!", vars)
    },
    'post-check-in': {
      header: interpolate('Welcome to {hotel}', vars),
      body: interpolate(
        "Hi {first}, welcome! Here's everything you need for a great stay, from dining hours to spa bookings.",
        vars
      ),
      cta: 'Explore Resort Amenities',
      successTitle: "You're all set!",
      successBody:
        'Thanks for confirming your details. Enjoy exploring the resort — our team is on hand for anything you need.',
      successClosing: 'We hope you have a wonderful stay!'
    },
    'post-checkout': {
      header: 'How was your stay?',
      body: interpolate(
        'Hi {first}, help other travelers with a quick review of your stay.',
        vars
      ),
      cta: 'Confirm',
      successTitle: "You're all set!",
      successBody: 'Thank you for sharing your feedback.',
      successClosing: interpolate('We hope to welcome you back to {hotel} soon!', vars)
    }
  }

  return configs[step] || configs['just-booked']
}
